import { render, staticRenderFns } from "./CopiarAulas.vue?vue&type=template&id=14354fa2&"
import script from "./CopiarAulas.vue?vue&type=script&lang=js&"
export * from "./CopiarAulas.vue?vue&type=script&lang=js&"
import style0 from "./CopiarAulas.vue?vue&type=style&index=0&id=14354fa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports